// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__27dRa","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2M4Y9","obliqueLine":"membershipbadge_obliqueLine__2xV1n"};